// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.error-page-container-N5P6y {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  padding: 32px;
  background-color: var(--color-white);
  text-align: center;
}

.error-page-content-TtrGT {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  max-width: 400px;
  width: 100%;
}

.error-page-textContainer-A9rju {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}

.error-page-errorIcon-p45ye {
  --size: 52px;
  color: var(--color-red-500);
  margin-bottom: 12px;
}

.error-page-title-rYJnC {
  color: var(--color-neutral-800);
  font-size: 28px;
  font-weight: var(--font-weight-medium);
  letter-spacing: var(--tracking-tight);
  margin: 0px;
}

.error-page-description-ShlIK {
  color: var(--color-neutral-600);
  line-height: var(--leading-relaxed);
  margin-top: 12px;
}

.error-page-supportSection-gNlY9 {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  width: 100%;
}

.error-page-supportHeader-fHNBC {
  display: flex;
  align-items: center;
  gap: 12px;
  color: var(--color-blue-500);
}

.error-page-supportIcon-rx5IY {
  --size: 32px;
}

.error-page-supportText-sF81R {
  color: var(--color-neutral-700);
  font-size: var(--text-base);
  font-weight: var(--font-weight-medium);
}

.error-page-supportLinks-wCakP {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.error-page-supportLink-GJwsR {
  font-size: var(--text-sm);
  font-weight: var(--font-weight-medium);
}
`, "",{"version":3,"sources":["webpack://./src/components/error-page/error-page.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,aAAa;EACb,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,eAAe;EACf,sCAAsC;EACtC,qCAAqC;EACrC,WAAW;AACb;;AAEA;EACE,+BAA+B;EAC/B,mCAAmC;EACnC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,4BAA4B;AAC9B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,+BAA+B;EAC/B,2BAA2B;EAC3B,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,sCAAsC;AACxC","sourcesContent":[".container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 100vh;\n  padding: 32px;\n  background-color: var(--color-white);\n  text-align: center;\n}\n\n.content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 12px;\n  max-width: 400px;\n  width: 100%;\n}\n\n.textContainer {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n}\n\n.errorIcon {\n  --size: 52px;\n  color: var(--color-red-500);\n  margin-bottom: 12px;\n}\n\n.title {\n  color: var(--color-neutral-800);\n  font-size: 28px;\n  font-weight: var(--font-weight-medium);\n  letter-spacing: var(--tracking-tight);\n  margin: 0px;\n}\n\n.description {\n  color: var(--color-neutral-600);\n  line-height: var(--leading-relaxed);\n  margin-top: 12px;\n}\n\n.supportSection {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 4px;\n  width: 100%;\n}\n\n.supportHeader {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  color: var(--color-blue-500);\n}\n\n.supportIcon {\n  --size: 32px;\n}\n\n.supportText {\n  color: var(--color-neutral-700);\n  font-size: var(--text-base);\n  font-weight: var(--font-weight-medium);\n}\n\n.supportLinks {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.supportLink {\n  font-size: var(--text-sm);\n  font-weight: var(--font-weight-medium);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `error-page-container-N5P6y`,
	"content": `error-page-content-TtrGT`,
	"textContainer": `error-page-textContainer-A9rju`,
	"errorIcon": `error-page-errorIcon-p45ye`,
	"title": `error-page-title-rYJnC`,
	"description": `error-page-description-ShlIK`,
	"supportSection": `error-page-supportSection-gNlY9`,
	"supportHeader": `error-page-supportHeader-fHNBC`,
	"supportIcon": `error-page-supportIcon-rx5IY`,
	"supportText": `error-page-supportText-sF81R`,
	"supportLinks": `error-page-supportLinks-wCakP`,
	"supportLink": `error-page-supportLink-GJwsR`
};
export default ___CSS_LOADER_EXPORT___;
